"use client"

import { useGetCertByNIK } from "@/actions/certificate"
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Label } from "@/components/ui/label"
import { Skeleton } from "@/components/ui/skeleton"
import { useState } from "react"
import { Input } from "../ui/input"

export default function Checker() {
  const [nik, setNik] = useState("")

  const {
    data: cert,
    isLoading: isLoadingCert,
    isSuccess: isSuccessCert,
  } = useGetCertByNIK(nik)

  return (
    <div className="space-y-8 pb-10 w-full ">
      <div className="flex gap-x-8  mx-auto ">
        <div className="space-y-3 w-full">
          <div className="grid gap-4">
            <Label className="text-txt16_24 font-medium">No NIK</Label>
            <Input
              placeholder="Masukan No NIK Anda"
              value={nik}
              className="py-3 text-txt16_24"
              onChange={(e) => {
                setNik(e.target.value)
              }}
            />
          </div>
          {isLoadingCert ? (
            <p className="font-medium">Sedang memuat data Anda...</p>
          ) : isSuccessCert ? (
            <p className="font-medium">
              Ditemukan{" "}
              <span className=" text-color-4">
                {cert?.certificates?.length} Pelatihan
              </span>
            </p>
          ) : (
            nik && <p className="font-medium">Format NIK tidak sesuai</p>
          )}
        </div>
      </div>
      <div className="grid md:grid-cols-3 gap-5">
        {isSuccessCert &&
          cert?.certificates?.map((data) => {
            console.log("hehe: ", data)
            return (
              <AlertDialog key={data?.id}>
                <AlertDialogTrigger asChild>
                  <Card className={"h-[200px] overflow-hidden cursor-pointer"}>
                    <CardContent className="p-0 flex justify-center items-center  hover:bg-color-4 hover:text-white  h-full hover:shadow-high text-txt18_28 font-semibold text-center">
                      {data?.training_name}
                    </CardContent>
                  </Card>
                </AlertDialogTrigger>
                <AlertDialogContent>
                  <AlertDialogHeader className={"sm:text-center"}>
                    <AlertDialogTitle>
                      <div>
                        <p>Cek Proses Sertifikat</p>
                        <p>A.N {cert?.name}</p>
                      </div>
                    </AlertDialogTitle>
                    <AlertDialogDescription className="text-black">
                      <div className="grid grid-cols-5 border-l border-r">
                        <div className="col-span-2 p-1 text-start border-t border-b font-medium">
                          Status Sertifikat
                        </div>
                        <div className="col-span-3 font-bold text-start border-l border-t p-1 border-b">
                          {data.status_message}
                        </div>
                      </div>
                      <div className="grid grid-cols-5 border-l border-r">
                        <div className="col-span-2 p-1 text-start border-b font-medium">
                          Pelatihan
                        </div>
                        <div className="col-span-3 text-start border-l text-wrap p-1 border-b">
                          {data.training_name}
                        </div>
                      </div>
                      <div className="grid grid-cols-5 border-l border-r">
                        <div className="col-span-2 p-1 text-start  border-b font-medium">
                          NIK
                        </div>
                        <div className="col-span-3 text-start border-l  p-1 border-b">
                          {data.nik}
                        </div>
                      </div>
                      <div className="grid grid-cols-5 border-l border-r">
                        <div className="col-span-2 p-1 text-start border-b font-medium">
                          Nomor Sertifikat
                        </div>
                        <div className="col-span-3 border-l text-start  p-1 border-b">
                          {data.no_seri === null
                            ? "Belum Ada No Sertifikat"
                            : data.number}
                        </div>
                      </div>
                      <div className="grid grid-cols-5 border-l border-r">
                        <div className="col-span-2 p-1 text-start border-b font-medium">
                          Nomor Peserta
                        </div>
                        <div className="col-span-3 border-l text-start p-1 border-b">
                          {data.no_participant}
                        </div>
                      </div>
                      <div className="grid grid-cols-5 border-l border-r">
                        <div className="col-span-2 p-1 text-start border-b font-medium">
                          Mitra Asal
                        </div>
                        <div className="col-span-3 border-l text-start p-1 border-b">
                          {!data.organizer ? "Daftar Mandiri" : data.organizer}
                        </div>
                      </div>

                      {/* <div className="grid grid-cols-5 border-l border-r">
                        <div className="col-span-2 p-1  border-b font-medium">
                          Nilai
                        </div>
                        <div className="col-span-3 border-l  p-1 border-b">
                          {data.grade === null ? "Belum Ada Nilai" : data.grade}
                        </div>
                      </div> */}
                    </AlertDialogDescription>
                  </AlertDialogHeader>
                  <AlertDialogFooter>
                    <AlertDialogCancel asChild className="bg-color-4 ">
                      <Button>Tutup</Button>
                    </AlertDialogCancel>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialog>
            )
          })}

        {isLoadingCert &&
          Array.from({
            length: 3,
          }).map((_, index) => {
            return <Skeleton key={index + 1} className={"h-[200px]"} />
          })}
      </div>
    </div>
  )
}
